/* eslint-disable max-lines */
export const Colors = {
  baseBrand500: '#077BC5',
};
